/* Geolocator */
window.addEventListener('DOMContentLoaded',customGeolocator);

// OK
var geolocatorClassesIds = {
    geolocatorWrapper: 'selectCountryWrapper',
    link: 'select-country-link'
};

//OK
var geolocatorCache = {};

//OK
function customGeolocator() {
    // debugger;
    // const defaultDomain = 'https://www.serapian.com';
    // const isDefault = isDefaultDomain(defaultDomain);

    /* Language Management */
    const language = geolocatorGetCookie('localization');
    if(!current_lang) current_lang = 'en';
    if(!language) {
        geolocatorUpdateCookie('localization',current_lang,false);
    } else {
        if(language !== current_lang) geolocatorUpdateCookie('localization',current_lang,false);
    }
    /* Language Management */

    /* Slug lang-country Management */
    const slug = geolocatorGetCookie('geolocator_slug');
    if(!current_slug) current_slug = '/';
    if(!slug) {
        geolocatorUpdateCookie('geolocator_slug',current_slug,false);
    } else {
        if(slug !== current_slug) geolocatorUpdateCookie('geolocator_slug',current_slug,false);
    }
    /* Slug lang-country Management */

    const shopifyAdminDomain = '.myshopify.com/admin',
        noGeoParam = 'nogeo',
        isAdmin = isAdminPreview(shopifyAdminDomain),
        noGeo = urlParam(noGeoParam);

    if(!isAdmin && !noGeo) {
        geolocatorCacheSelectors();
        changeCountryEvents();
        // debugger;
        const country = geolocatorGetCookie('localization');
        // console.log('country',country);
        // debugger;
        if(!country) {
            // debugger;
            getIpCountry(false);
        } else if(geolocatorCache.geolocatorWrapper) {
            // debugger;
            checkUrl(country,true);
        }
        // debugger;
    }
}

//OK
function urlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) return null;
    return results[1] || 0;
}

//OK
function keepUrlParams() {
    let res = {};
    const self = window.location.toString(),
        querystring = self.split("?");
    if(querystring.length > 1) {
        const pairs = querystring[1].split("&");
        for(i in pairs) {
            let keyval = pairs[i].split("=");
            //if(keyval[0].indexOf('utm_') > -1) res[keyval[0]] = decodeURIComponent(keyval[1]);
            res[keyval[0]] = decodeURIComponent(keyval[1]);
        }
    }
    return res;
}

//OK
function updateQueryStringParameter(uri, key, value) {
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i"),
        separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if(uri.match(re)) return uri.replace(re, '$1' + key + "=" + value + '$2');
    return uri + separator + key + "=" + value;
}

//OK
function isAdminPreview(shopifyAdminDomain) {
    if(window.parent.location.href.indexOf(shopifyAdminDomain) > -1) return true;
    return false;
}

/*
  function isDefaultDomain(defaultDomain) {
    if(defaultDomain == window.location.origin) {
        getIpCountry();
        return true;
    }
    return false;
  }
*/
// var test1, test2;
// OK - TO REVISE
function checkUrl(countryIsoCode,cond) {
    // debugger;
    // Refactor es6
    const linkSelector = document.querySelector('.'+geolocatorClassesIds.link+'[data-country="'+countryIsoCode+'"]');
    // debugger;
    // console.log('linkSelector',linkSelector);
    if(linkSelector) {
        // debugger;
        // TBR -- remove extra param
        // if(!cond) {
        //   const _associatedUrlSeparator = geo_country_map[countryIsoCode].slug ? '/' : '';
        //   window.location.href = window.location.origin+"/"+geo_country_map[countryIsoCode].slug+_associatedUrlSeparator+geo_prefix+geo_handle;
        //   return;
        // }
        // TBR -- remove extra param
        const _linkSelector = linkSelector.getAttribute('href').endsWith('/') ? linkSelector.getAttribute('href') : linkSelector.getAttribute('href')+'/';
        console.log('_linkSelector',_linkSelector);
        // const _geo_domain = linkSelector.getAttribute('href') ? geo_domain.replace(/\//g, '') : geo_domain,
        const _geo_domain = _linkSelector ? geo_domain.replace(/\//g, '') : geo_domain,
            // _associatedUrlSeparator = geo_country_map[countryIsoCode].slug ? '/' : '',
            _associatedUrlSeparator = '',
            associatedUrl = geo_protocol+_geo_domain+linkSelector.getAttribute('href');
        // _checkAgainst = window.location.origin+"/"+_slug+_associatedUrlSeparator;
        let _checkAgainst = '';
        // console.log('countryIsoCode:',countryIsoCode);
        // console.log('CURRENT SLUG:',_slug);
        // console.log('associatedUrl',associatedUrl);
        // console.log('vs');
        // console.log('_checkAgainst',_checkAgainst);
        // debugger;
        // console.log('...........................................');
        // if(associatedUrl != window.location.origin+"/"+geo_country_map[countryIsoCode].slug+_associatedUrlSeparator) {
        // test1 = associatedUrl;
        // test2 = _checkAgainst;

        // URL NOT MATCHING -- REDIRECT TO VISITOR COUNTRY
        let urlMatching = false;
        // debugger;
        if(_langs && _langs.length > 0) {
            // debugger;
            _langs.forEach(_l => {
                // debugger;
                if(!urlMatching) {
                    // debugger;
                    _checkAgainst = window.location.origin+_l+_associatedUrlSeparator;
                    urlMatching = associatedUrl != _checkAgainst ? false : true;
                }
            });
        }
        // debugger;
        // if(associatedUrl != _checkAgainst) {
        if(!urlMatching) {
            let _urlSeparator = geo_country_map[countryIsoCode].slug !== "" ? "/" : "",
                newUrl = geo_protocol+geo_domain+geo_country_map[countryIsoCode].slug+_urlSeparator+geo_prefix+geo_handle,
                keptParams = keepUrlParams();
            if(keptParams) {
                for(const [key, value] of Object.entries(keptParams)) {
                    newUrl = updateQueryStringParameter(newUrl,key,value);
                }
            }
            // debugger;
            // Country no matching => redirect, better check for the cart
            // debugger;
            geolocatorClearCookie('check_cart');
            const curr_saved_lang = geolocatorGetCookie('localization');
            let acc_lang = false;
            geo_country_map[countryIsoCode].langs.forEach(l => {
                if(l === curr_saved_lang) acc_lang = true;
            });
            if(!acc_lang) geolocatorUpdateCookie('geolocator_language',geo_country_map[countryIsoCode].dl,false);
        }
        // URL NOT MATCHING -- REDIRECT TO VISITOR COUNTRY

        // URL MATCHING
        // debugger;
        let geolocatorLink = null;
        if(document.querySelector('.'+geolocatorClassesIds.link+'[data-country="'+countryIsoCode+'"]')) geolocatorLink = document.querySelector('.'+geolocatorClassesIds.link+'[data-country="'+countryIsoCode+'"]');
        if(geolocatorLink) {
            geolocatorLink.className = 'select-country-link select-country-link--active Link Link--underline';
            const _id = geolocatorLink.closest('.TabPanel') ? geolocatorLink.closest('.TabPanel').id : null;
            if(_id && document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`)) {
                geolocatorLink.closest('.TabPanel').setAttribute('aria-hidden',false);
                document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).dataset.active = "true";
                document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).classList.add('is-active');
                document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).setAttribute('aria-selected',true);
                document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).querySelector('.Custom__TabList-InnerItem').classList.add('is-active');
                document.querySelector(`#sidebar-country .Custom__TabList-Item[aria-controls="${_id}"]`).querySelector('.Custom__TabList-InnerItem').dataset.active = "true";
            }
        }
        if(document.querySelector('.country-language-wrapper .country-current-val') && geolocatorLink) document.querySelector('.country-language-wrapper .country-current-val').textContent = geolocatorLink.textContent;
        // debugger;
        // REVISE (fare per desktop e nel main menu su mobile)
        if(document.querySelector('.country-selector-wrapper')) {
            // Refactor es6
            document.querySelectorAll('.country-selector-wrapper').forEach(el => {
                // el.querySelector('.country-selector--country').textContent = document.querySelector('.'+geolocatorClassesIds.link+'[data-country="'+countryIsoCode+'"]').textContent;
                el.querySelector('.country-selector--country').textContent = countryIsoCode;
                // el.querySelector('.country-selector--language').textContent = geo_country_map[countryIsoCode].dl;
            });
        }

        getCountries();
        addNlTag(countryIsoCode);

        // debugger;
        console.log('verifycheckCart');
        const check_cart = geolocatorGetCookie('check_cart');
        console.log('check_cart:',check_cart);
        // debugger;
        if(check_cart && check_cart === '1') {
            console.log('no need to check cart - v2');
            return;
        }
        geolocatorUpdateCookie('check_cart','1',false);
        checkCart();
        // URL MATCHING

    }
}

function addNlTag(countryIsoCode) {
    const nlFooterVal = $('#contactTagsFooter').val()
    const nlPopupVal = $('#contactTagsPopup').val()
    const tag = 'country-'+countryIsoCode

    $('#contactTagsFooter').val(nlFooterVal+ ', ' + tag)
    $('#contactTagsPopup').val(nlPopupVal+ ', ' + tag)
}

// OK
function getIpCountry(cond) {
    // debugger;
    let geoIpCountry;
    fetch('https://geoip.service.triboo.it/', {
        headers: {
            'Security-Header': '8375tmsQREZA-'
        }
    }).then((response) => {
        // console.log(response);
        // debugger;
        if(response.ok)
            return response.text();
    }).then(locale => {
        // debugger;
        geoIpCountry = locale;
        if (geoIpCountry) {
            geolocatorUpdateCookie('geolocator_country',geoIpCountry,false);
            _currCountry = geoIpCountry;
            // debugger;
            checkUrl(geoIpCountry,cond);
        } else {
            geoIpCountry = 'IT';
            geolocatorClearCookie('geolocator_country');
            _currCountry = 'IT';
            checkUrl(geoIpCountry,cond);
        }
    }).catch(err => {
        console.error(err);
        geolocatorClearCookie('geolocator_country');
    });
}

// Forse da aggiungere cookie "location" di Shopify
function geolocatorUpdateCookie(key,value,deleteCookie) {
    // debugger;
    // const domain = 'serapian.com';
    const domain = _staging ? 'scholl-shoes-markets.myshopify.com' : 'scholl-shoes.com';
    let expires = '';
    if(deleteCookie) {
        let d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*-1);
        expires = `;expires=${d.toGMTString()}`;
    }
    document.cookie = `${key}=${value};path=/;domain=${domain}${expires}`;
}

// Forse da aggiungere cookie "location" di Shopify
function geolocatorClearCookie(key) {
    geolocatorUpdateCookie(key,'',true)
}

function changeCountryEvents() {
    // const elements = document.getElementsByClassName(geolocatorClassesIds.link);
    // Array.from(elements).forEach(function(element) {
    document.querySelectorAll(`.${geolocatorClassesIds.link}`).forEach(el => el.addEventListener('click', getLinkAttr));
}

// OK
function getLinkAttr(event) {
    let currLink = event.currentTarget;
    if(currLink) {
        // debugger;
        // So the check cart function runs of change country
        geolocatorClearCookie('check_cart');
        event.preventDefault();
        let currCountry = currLink.getAttribute('data-country');
        if(currCountry) {
            geolocatorUpdateCookie('geolocator_country',currCountry,false);
            _currCountry = currCountry;
        }
        // if(geo_country_map[currCountry] === undefined || geo_country_map[currCountry].dl === undefined || geo_country_map[currCountry].dl === 'en') {
        // window.location.href = currLink.getAttribute('href');
        /* */
        const countryIsoCode = geolocatorGetCookie('geolocator_country');
        if(!countryIsoCode) {
            window.location.href = currLink.getAttribute('href');
            return;
        }
        let _urlSeparator = geo_country_map[countryIsoCode].slug !== "" ? "/" : "",
            newUrl = geo_protocol+geo_domain+geo_country_map[countryIsoCode].slug+_urlSeparator+geo_prefix+geo_handle,
            keptParams = keepUrlParams();
        if(keptParams) {
            for(const [key, value] of Object.entries(keptParams)) {
                newUrl = updateQueryStringParameter(newUrl,key,value);
            }
        }
        // debugger;
        if(newUrl) {
            console.log('Redirect to: ',newUrl);
            window.location.href = newUrl;
        } else { // Fallback
            console.log('Redirect to: HP (fallback): ',currLink.getAttribute('href'));
            window.location.href = currLink.getAttribute('href');
        }
        /* */
        // } else {
        // const newUrl = `${currLink.getAttribute('href')}/${geo_country_map[currCountry].dl}`;
        // window.location.href = newUrl;
        // }
    }
}

// OK
function geolocatorCacheSelectors() {
    geolocatorCache = {
        body: document.body,
        geolocatorWrapper: document.getElementById(geolocatorClassesIds.geolocatorWrapper)
    };
}

// OK
function geolocatorGetCookie(name) {
    /* Method 1
     name = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    } */
    /* MEthod 2
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    */

    const geoSlugMatch = document.cookie.match('(^|;) ?geolocator_slug=([^;]*)(;|$)');
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    const geoSlug = geoSlugMatch ? geoSlugMatch[2] : null;

    if (v) {
        if (geoSlug !== '/' && geoSlug !== null) {
            return v[2];
        } else if (geoSlug === '/') {
            return 'IT';
        }
    }

    return null;
}

/* Geolocator */

/* Shopify Markets - Check Cart */
//window.addEventListener('DOMContentLoaded', verifycheckCart);
var _nuc = {};
// function verifycheckCart() {

// }
function checkCart() {
    // debugger;
    console.log('check Cart');
// debugger;
    const nocommerce = checkNoCommerce();
    console.log('is no-commerce:', nocommerce);
    if(nocommerce) return;
// debugger;
    if(!_cart) {
        console.log('----------------- CART 1 -------------------------');
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                _cart = data;
                console.log(data);
                console.log('----------------- CART 1 -------------------------');
                console.log(`__cart: ${data}`);
                if(_cart && _cart.items) iterateOverProds(data.items);
            }).catch(function(error) {
            console.error(`Error retreiving cart: ${error}`);
            _cart = null;
        });
        return;
    }
    if(_cart && _cart.items) iterateOverProds(_cart.items);
}
function checkNoCommerce() {
    if(!nocommerce_markets) return false;
    let res = false;
    nocommerce_markets.split(',').forEach(_c => {
        __cm[_c].forEach(country => {
            if(country === current_market) res = true;
        });
    });
    if(!res) return false;
    if(!_cart) {
        console.log('----------------- CART 2 -------------------------');
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                _cart = data;
                console.log(data);
                console.log('----------------- CART 3 -------------------------');
                console.log(`__cart: ${data}`);
                clearCart();
            }).catch(function(error) {
            console.error(`Error retreiving cart: ${error}`);
            _cart = null;
        });
    } else {
        clearCart();
    }
    return true;
}
function clearCart() {
    if(_cart && _cart.items && _cart.items.length > 0) {
        alert(`Siamo spiacenti, non è possibile acquistare in questa country. Il carrello verrà svuotato e la pagina verrà ricaricata automaticamente.`);
        fetch('/cart/clear.js')
            .then(response => response.json())
            .then(data => {
                _cart = data;
                console.log('cleared cart:');
                console.log(data);
                console.log('----------------- CART 3 -------------------------');
                location.reload();
            }).catch(function(error) {
            console.error(`Error retreiving cart: ${error}`);
            _cart = null;
        });
    }
}
function iterateOverProds(els) {
    // debugger;
    console.log('iterateOverProds');
    console.log('iterateOverProds',els);
    let _updatedCart = false;
    els.forEach((el, i) => {
        if(!el.properties._prod_tags) {
            _nuc[el.id] = 0;
            _updatedCart = true;
            return;
        }
        if(el.properties._prod_tags.indexOf('__do_not_sell_to:') < 0) {
            _nuc[el.id] = el.quantity;
            return;
        }
        const excluded_country_obj = el.properties._prod_tags.match(/__do_not_sell_to:(.*?),/i);
        if(!excluded_country_obj) return;
        const countries = excluded_country_obj[1].replace(/_/g, ',').replace(/\*/g, '_');
        if(!countries) return;
        countries.split(',').forEach(c => {
            if(__cm[c]) {
                // debugger;
                __cm[c].forEach(_c => {
                    // debugger;
                    if(_c === current_market) {
                        // debugger;
                        console.log('_c',_c);
                        _nuc[el.id] = 0;
                        _updatedCart = true;
                    }
                    console.log('updateCart',updateCart);
                });
            }
        });
    });
    console.log('_nuc',_nuc);
    // debugger;
    if(!_updatedCart) return;
    // debugger;
    if(_nuc && Object.keys(_nuc).length === 0 && Object.getPrototypeOf(_nuc) === Object.prototype) return;
    // debugger;
    updateCart();
}
function updateCart() {
    // debugger;
    alert(_updateCartAlertText);
    const request = {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ updates: _nuc })
    };
    fetch('/cart/update.js', request)
        .then(response => response.json())
        .then(data => {
            console.log('updated cart');
            location.reload();
        }).catch(function(error) {
        console.error(`Error retreiving cart: ${error}`);
    });
}
/* Shopify Markets - Check Cart */
